export default __webpack_public_path__ + "670bf8a3c5219adf2f860f0f867abd80.png";